var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 109.999C87.6142 109.999 110 87.6133 110 59.999C110 32.3848 87.6142 9.99902 60 9.99902C32.3858 9.99902 10 32.3848 10 59.999C10 87.6133 32.3858 109.999 60 109.999Z",
    stroke: "currentColor",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5068 73.2234C40.1918 74.5614 40.1214 77.0262 41.5538 78.4347C42.9861 79.8666 45.4282 79.8197 46.7667 78.4816L60.0102 65.2421L73.2304 78.4582C74.6158 79.8666 77.0109 79.8432 78.4198 78.4112C79.8521 77.0028 79.8521 74.6084 78.4667 73.2234L65.2466 60.0073L78.4667 46.7677C79.8521 45.3827 79.8521 42.9884 78.4198 41.5799C77.0109 40.148 74.6158 40.148 73.2304 41.5329L60.0102 54.749L46.7667 41.5095C45.4282 40.1949 42.9626 40.1245 41.5538 41.5564C40.1449 42.9884 40.1918 45.4297 41.5068 46.7677L54.7504 60.0073L41.5068 73.2234Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic-error.ba8e7d63738112afb913c46451d47d51.svg";
export { ForwardRef as ReactComponent };